import { Document, Page, Text, View } from '@react-pdf/renderer';
import { MyFleetVessel } from '../../models/my-fleet.model';
import { ProReportResponse } from '../../models/pro.model';
import DestinationDisclaimer from './pro-report-pdf-components/pro-report-destination-disclaimer';
import DestinationPort from './pro-report-pdf-components/pro-report-destination-port';
import FirstCallInfo from './pro-report-pdf-components/pro-report-first-call-info';
import ProReportFooter from './pro-report-pdf-components/pro-report-footer';
import ProReportHeader from './pro-report-pdf-components/pro-report-header';
import ClubContact from './pro-report-pdf-components/pro-report-pdf-club-contact';
import Copyright from './pro-report-pdf-components/pro-report-pdf-copyright';
import CorrespondentContact from './pro-report-pdf-components/pro-report-pdf-correspondent-contact';
import CorrespondentFeedback from './pro-report-pdf-components/pro-report-pdf-correspondent-feedback';
import Disclaimer from './pro-report-pdf-components/pro-report-pdf-disclaimer';
import Feedback from './pro-report-pdf-components/pro-report-pdf-feedback';
import LossPreventionCommentary from './pro-report-pdf-components/pro-report-pdf-loss-prevention-commentary';
import RiskTable from './pro-report-pdf-components/pro-report-risk-table';
import SecurityAdvice from './pro-report-pdf-components/pro-report-security-advice';
import styles from './pro-report-pdf-styles';

interface ProReportExportProps {
  report: ProReportResponse;
  portName?: string;
  portCountry?: string;
  portUnlocode?: string;
  vessel?: MyFleetVessel;
  aisRawDestination?: string | null;
}

function ProReportExport({
  report,
  portName,
  portCountry,
  portUnlocode,
  vessel,
  aisRawDestination,
}: ProReportExportProps) {
  if (!report)
    return (
      <Document>
        <Page size="A4" style={styles.page}>
          <ProReportHeader />
          <View style={styles.hr} />
          <Text>Report Not Available</Text>
          <CorrespondentContact />
          <View style={styles.hr} />
          <ClubContact />
          <ProReportFooter />
        </Page>
      </Document>
    );

  let correspondentDescription = null;
  if (report.correspondent_contact) {
    const { name } = report.correspondent_contact;
    const { company } = report.correspondent_contact;
    if (name && company) {
      correspondentDescription = `${name} (${company})`;
    } else if (name) {
      correspondentDescription = name;
    } else if (company) {
      correspondentDescription = company;
    }
  }
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <ProReportHeader />
        <View style={styles.hr} />
        <DestinationDisclaimer
          portName={portName}
          portUnlocode={portUnlocode}
          aisDestination={aisRawDestination}
        />
        <DestinationPort
          portName={portName}
          portUnlocode={portUnlocode}
          portCountry={portCountry}
        />
        <View style={styles.hr} />
        <RiskTable report={report} vessel={vessel} />
        <View style={styles.hr} />
        <LossPreventionCommentary lossPreventionAdvice={report.claims_advice} />
        <View style={styles.hr} />
        <CorrespondentFeedback
          correspondentAdvice={report.correspondent_advice}
          correspondentDescription={correspondentDescription}
        />
        <View style={styles.hr} />
        {/* Spacer added by Security Advice if present */}
        <SecurityAdvice securityAdvice={report.security_advice} />
        <CorrespondentContact
          correspondentContact={report.correspondent_contact}
        />
        <View style={styles.hr} />
        <FirstCallInfo firstCallInfo={report.first_call_info} />
        {/* Spacer added by First Call Info if present */}
        <ClubContact />
        <View style={styles.hr} />
        <Feedback />
        <View style={styles.hr} />
        <Disclaimer />
        <View style={styles.hr} />
        <Copyright />
        <ProReportFooter />
      </Page>
    </Document>
  );
}

ProReportExport.defaultProps = {
  portName: '',
  portUnlocode: '',
  portCountry: '',
  vessel: undefined,
  aisRawDestination: null,
};

export default ProReportExport;
